import theme from '@/constants/theme';

const styles: Record<string, React.CSSProperties> = {
  stageContainer: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    margin: '0px 16px',
    borderLeft: '3px solid #ffffff1a',
  },
  stagesItems: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: theme.colors.secondary,
    margin: '8px 16px',
    marginRight: 0,
    padding: '16px',
    borderRadius: 8,
    gap: 8,
    border: 'none',
    color: theme.colors.text.body,
    textAlign: 'left',
    cursor: 'pointer',
    position: 'relative',
  },
  listIndicator: {
    width: 10,
    height: 10,
    borderRadius: 100,
    backgroundColor: theme.colors.primary,
    position: 'absolute',
    top: 40,
    left: -7,
  },
  stageDetails: {
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
  },
};

export default styles;
